import { postData, getData, patchData, dynamicPostData } from "./index"
import axios from "axios";
import config from '../env/config'
import Config from "../env/config";

export const getAllChannels = (id, obj) => {
  // console.log("oooo",obj);
  let data = {
    query: `query { getChannels(payload: { channelName: "${id}" })
    { _id 
      ${obj}
    } 
  } `
  }
  return postData(data);
};

export const getMotorEnquiry = (enquiryId) => {
  let configJson = {
    url: `${Config.BASE_URL}/graphql-api/graphql?`,
    method: "post",
    headers: { "Content-Type": "application/json", "Cookies": document.cookie.toString() },
    data: {
      query: `query {
      getMotorEnquiry(enquiryId: "${enquiryId}") {
        enquiry_id
       otherVehicleDetails {
         metaData
           idv
         }
         registrationYear
         makeModelVariant
         policyType
         vehicleNumber
         model
         metaData
         userId
         channel
         created_by_userId
       }
     }`
    }
  };
  return axios(configJson).then(resp => {
    if (resp?.data) {
      return resp?.data;
    }
  }).catch(err => {
    return err;
  });
}

export const channelPremiumDomestic = (payload) => {
  let query = {
    query: `query {
          channelPremiumDomestic(
            payload: ${JSON.stringify(payload).replace(/\"([^(\")"]+)\":/g, "$1:")}
          )
 {
    code
    total
    succeed
    failed
    value {
      productId
      productCode
      name
      defaultProduct
      companyCode
      companyName
      category
      addons {
        name
        desc
        isDefault
        type
        listing
        param {
          name
          values {
            code
            value
          }
        }
      }
      assets {
        images {
          uri
        }
        brouchers {
          uri
          name
          nameArabic
          uriArabic
        }
        hospitalDocs {
          uri
          name
          nameArabic
          uriArabic
        }
      }
      faqs{
        que
        ans
        queArabic
        ansArabic
      }
      exclusions {
        desc
        notes
        name
        nameArabic
      }
      benefits {
        name
        desc
        nameArabic
        group
        sumInsured
        category
        images {
          type
          uri
        }
        waitingPeriod {
          value
          units
        }
        notes
        subLimit {
          occurance
          value {
            num
            units
          }
        }
        benefitTypeValue
        benefitType
        deductibleOrCopay {
          payType
          value
          type
        }
      }
      comments
      commentsArabic
      remarks
      smallPrintConditions
      highlights {
        ben
        desc
        benArabic
        descArabic
        images {
          uri
        }
      }
      keyHighlights {
        ben
        desc
        benArabic
        descArabic
        images {
          uri
        }
      }
      recommended
      calculations {
        value {
          currencyType
          sumAssured
          totalPremium
          productId
          addonIdList
          serviceTax
          basePremium
          quoteId
          addonIdList
          addonIdListValues{
            addonCode
            isSelected
            addonName
            addonBasePremium
            addonTotalPremium
            addonServiceTax
          }
        }
      }
    }
  }
      }`
  };
  return postData('/graphql-api/graphql?', query);
};

export const updateMotorEnquiry = (id, payload) => {
  let query = {
    query: `mutation {
        updateMotorEnquiry(
          enquiryId: "${id}",
          payload: {
            enquiry_id: "${payload.enquiry_id}",
            metaData: ${JSON.stringify(payload.metaData)},  
            otherVehicleDetails: {
           idv: "${payload.otherVehicleDetails.idv}",
              metaData: ${JSON.stringify(payload.otherVehicleDetails.metaData)}  
            },
            policyType: "${payload.policyType}",
             created_by: "USER",
          }
        ) {
          enquiry_id
          status
        }
      }`
  };

  return postData('/graphql-api/graphql?', query);
};

export const channelPremiumMotor = (payload) => {
  let query = {
    query: `query {
            channelPremiumMotor(
                payload: ${JSON.stringify(payload).replace(/\"([^(\")"]+)\":/g, "$1:")}
            ) {
                minimumIdv
                maximumIdv
                recommendedIdv
                value {
                    productId productCode
                    category
                    name
                    productNameArabic
                    isFullfillmentMode
                    isPolicyFullfillment
                    addons {
                        name
                        desc
                        isDefault
                        listing
                    }
                    assets {
                        images {
                            uri
                        }
                    }
                    calculations {
                        code
                        message
                        value {
                            idvData {
                                idv
                            }
                            personalAccident {
                                isSelected
                                totalPremium
                                basePremium
                                serviceTax
                                code
                                name
                            }
                            addonIdListValues {
                                addonCode
                                isSelected
                                addonName
                                addonBasePremium
                                addonTotalPremium
                                addonServiceTax
                            }
                            legalLiabilityCover {
                                name
                                code
                                isSelected
                                basePremium
                                totalPremium
                                serviceTax
                                minSumAssured
                                maxSumAssured
                            }
                            unnamedPA {
                                name
                                code
                                isSelected
                                basePremium
                                totalPremium
                                serviceTax
                                minSumAssured
                                maxSumAssured
                            }
                            accessoriesCover {
                                name
                                code
                                isSelected
                                basePremium
                                totalPremium
                                serviceTax
                                minSumAssured
                                maxSumAssured
                            }
                            quoteId
                            productId
                            basePremium
                            totalPremium
                            sumAssured
                            serviceTax
                            tpPremium
                            odPremium
                            discounts {
                                discountType
                                discountPercent
                                discountAmount
                            }
                        }
                    }
                    NCBCover
                    sharedRoom
                    privateRoom
                    recommended
                    popularity
                    highlights {
                        desc
                        ben
                    }
                    benefits {
                        name
                        nameArabic
                    }
                    summary
                    diabetes
                    companyName
                    companyCode
                    channelMapping
                    code
                    categoryType
                    productVariant
                }
            }
        }`
  };

  // Send the GraphQL request using postData function
  return postData('/graphql-api/graphql?', query);
};

export const channelPremiumTravel = (payload) => {
  let query = {
    query: `query {
          channelPremiumTravel(
              payload: ${JSON.stringify(payload).replace(/\"([^(\")"]+)\":/g, "$1:")}
          ) {
    code
    total
    succeed
    failed
    value {
      productId
      productCode
      name
      defaultProduct
      companyCode
      companyName
      category
      addons {
        name
        desc
        isDefault
        type
        listing
        param {
          name
          values {
            code
            value
          }
        }
      }
      assets {
        images {
          uri
        }
        brouchers {
          uri
          name
          nameArabic
          uriArabic
        }
      }
      faqs{
        que
        ans
        queArabic
        ansArabic
      }
      exclusions {
        desc
        notes
        name
      }
      benefits {
        name
        nameArabic
      }
      comments
      commentsArabic
      remarks
      smallPrintConditions
      highlights {
        ben
        benArabic
        desc
        images {
          uri
        }
      }
      keyHighlights {
        ben
        desc
        benArabic
        descArabic
        included
        images {
          uri
        }
      }
      recommended
      calculations {
        value {
          currencyType
          sumAssured
          totalPremium
          productId
          addonIdList
          serviceTax
          basePremium
          quoteId
          addonIdList
          addonIdListValues{
            addonCode
            isSelected
            addonName
            addonBasePremium
            addonTotalPremium
            addonServiceTax
          }
        }
      }
    }
  }
      }`
  };

  // Send the GraphQL request using postData function
  return postData('/graphql-api/graphql?', query);
};

export const updateVehicleOrder = (id, payload) => {
  const fields = [`insurerJson:${JSON.stringify(payload.insurerJson)}`];
  if (payload.metaData !== undefined) {
    fields.push(`metaData:${JSON.stringify(payload.metaData)}`);
  }
  let query = {
    query: `mutation {
      updateVehicleOrder(
        orderId: "${id}",
        payload: {
        ${fields.join('\n        ')}
        }
      ) {
        order_id
        insurerJson
      }
    }`
  };

  return postData('/graphql-api/graphql?', query);
};

export const updateCancellationReasonApi = (path, payload) => {
  return fetch(path, {
    method: "PATCH",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  }).then((res) => res.json());
};


export function createMotorOrder(payload) {
  let query = {
    query: `mutation {  createVehicleOrder(
                      payload: ${payload}
                    ) {
                      order_id
                      enquiry_id
                      created_by_userId
                      created_for_userId
                    }
                  }`
  }


  return postData('/graphql-api/graphql?', query);
}


// all above are for motor

export const getUser2 = (url) => {
  return getData(url);
};

export const getUser = (url, mobileNum) => {
  return postData(url, { phoneNumber: mobileNum });
};
export const createUser = (url, data) => {
  // eslint-disable-next-line no-unused-vars
  const { firstName, lastName, middleName, countryCode, mobileNumber } = data;
  // return postData(url,{phoneNumber: countryCode+mobileNumber,fullName:`${firstName} ${middleName} ${lastName}`});
  return postData(url, { phoneNumber: countryCode + mobileNumber, fullName: `` });

};

export const createLifeEnquiry = (url, request) => {
  const { payload, response } = request;
  // console.log("paya",payload);
  let query = {
    query: `mutation { createLifeEnquiry(
    payload: ${JSON.stringify(payload).replace(/\"([^(\")"]+)\":/g, "$1:")}
    )
    { 
      ${response}
    } 
  } `
  }
  return postData(url, query);
}

export const updateLifeEnquiry = (url, request) => {
  const { enquiryId, payload, response } = request;
  // console.log("paya",payload);
  let query = {
    query: `mutation { updateLifeEnquiry(
      enquiryId:${JSON.stringify(enquiryId).replace(/\"([^(\")"]+)\":/g, "$1:")}
    payload: ${JSON.stringify(payload).replace(/\"([^(\")"]+)\":/g, "$1:")}
    )
    { 
      ${response}
    } 
  } `
  }
  return postData(url, query);
}
export const getLifeEnquiry = (url, request) => {
  const { payload, response } = request;
  // console.log("paya",payload);
  let query = {
    query: `query { getLifeEnquiry(
      enquiryId: ${JSON.stringify(payload).replace(/\"([^(\")"]+)\":/g, "$1:")}
    )
    { 
      ${response}
    } 
  } `
  }
  return postData(url, query);
}

export const getChannelPremiumLife = (url, request) => {
  const { payload, response } = request;
  // console.log("quote payload ==> ", payload);
  let query = {
    query: `query { channelPremiumLife(
      payload: ${JSON.stringify(payload).replace(/\"([^(\")"]+)\":/g, "$1:")}
    ){
      ${response}
    } }`
  }
  return postData(url, query);
};

export const createLifeOrder = (url, request) => {
  const { payload, response } = request;
  // console.log("paya",payload);
  let query = {
    query: `mutation { createLifeOrder(
    payload: ${JSON.stringify(payload).replace(/\"([^(\")"]+)\":/g, "$1:")}
    )
    { 
      ${response}
    } 
  } `
  }
  return postData(url, query);
};

export const getLifeOrder = (url, id) => {
  let query = {
    query: `query{getLifeOrder(orderId:${JSON.stringify(id).replace(/\"([^(\")"]+)\":/g, "$1:")}){order_id enquiry_id quote{
    productId
  }}}`
  };
  return postData(url, query);
};


export const getChannelValueList = (channel, listName, productCode) => {
  let query = {
    query: `query {
          getChannelValueLists(
            listName: "${listName}"
            channel: "${channel}"
            productCode: "${productCode}"
            )
          }`
  };

  return postData('/graphql-api/graphql?', query);
};
export const getproductMaterValueList = (productCode) => {
  let query = {
    query: `query {
           getChannelValueLists(
             productCode: "${productCode}"
             )
           }`
  };

  return postData('/graphql-api/graphql?', query);
};

export const fetchValueList = (listName) => {
  const query = {
    query: `query {
      getChannelValueLists(
        listName: "${listName}"
        channel: "default"
      )
    }`
  };
  return postData("/graphql-api/graphql?", query).then((response) => {
    return response?.data?.data?.getChannelValueLists?.[0]?.listData || response?.data?.getChannelValueLists?.[0]?.listData || [];
  });
};

export const fetchChannelsList = () => {
  const query = {
    query: `query {
      getChannels(payload: { isActive: true }) {
        _id
        channelName
        channelDesc
        business
        category
      }
    }`
  };
  return postData("/graphql-api/graphql?", query).then((response) => {
    return (
      response?.data?.data?.getChannels ||
      response?.data?.getChannels ||
      []
    );
  });
};

export const getValueList = (channel, listName) => {
  let query = {
    query: `query {
            getChannelValueLists(
              listName: "${listName}"
              channel: "${channel}"
              )
            }`
  };
  return postData('/graphql-api/graphql?', query);
};
export const newGetValueList = (productCode, listName) => {
  let query = {
    query: `query {
            getChannelValueLists(
              listName: "${listName}"
              productCode: "${productCode}"
              )
            }`
  };
  return postData('/graphql-api/graphql?', query);
};

export const getChannelValueListMaster = (channel, listName) => {
  let query = {
    query: `query {
           getChannelValueList(
             listName: "${listName}"
             channel: "${channel}"
             )
           }`
  };

  return postData('/graphql-api/graphql?', query);
}

export const getVehicleDetailsApi = (enquiryId) => {
  const url = `${Config.CHANNEL_PARTNER_INSURER}/v1/channelPartner/getVehicleDetails`;
  return dynamicPostData(url, { enquiryId });
};

export const getProductWithId = (id) => {
  let query = {
    query: `query {getProducts(payload:{
      _id:"${id}"
      }){
        _id
        category
        categoryCode
        parentCategory
        parentCode
        premiumScore
        sumAssuredFactor
        maximumSumAssured
        name
        title
        isPolicyFullfillment
        isFullfillment
        isFullfillmentMode
        productRedirectionURL
        rating
        companyId
        description
        primaryInsuredAgeLimit
        membersAge
        childsAge
        productCode
        planID
        comments
        clamSettlementScore
        benefitsScore
        conditionsScore
        serviceQualityScore
        financialStrengthScore
        premiumScore
        NCBCover
        sharedRoom
        privateRoom
        recommended
        popularity
        summary
        diabetes
        companyCode
        premiumCalculatorService
        companyName
        basePremium
        productType
        categoryType
        productVariant
        paymentMode
         faqs {
         que
         ans
         queArabic
         ansArabic
         }
        childAgeLimit{
          min
        max}
        noOfAdultsLimit
        maleAgeLimit{
          min
          max
        }
        femaleAgeLimit{
          min
          max
        }
        genderLimit
        coverageAmountLimit
          addons {
          name
          nameArabic
          desc
          descArabic
          listing
          type
          isDefault
          addOnType
          
          images {
            type
            uri
          }
          addOnValues {
            name
            value
          }
          param {
            name
            values {
              code
              value
            }
          }
        }
        highlights {
          ben
          benArabic
          desc
          descArabic
          images {
            type
            uri
          }
        }
        compareFeatures { desc name shortDesc score visibility }
        benefits {
          name
          nameArabic
          desc
          order
          benefitCode
          images {
            type
            uri
          }
        }
        exclusions {
          name
          nameArabic
          desc
          order
          notes
          images {
            type
            uri
          }
        }
        assets{
          brouchers{ 
          uri 
          name
          nameArabic
           }
          images {
            type
            uri
          }
        }
      }
      }
     }`
  }
  return postData('/graphql-api/graphql?', query);
}

export const getMotorOrderWithId = (id) => {
  const query = {
    query: `query {
      getVehicleOrder(orderId:"${id}") {
        enquiry_id
        order_id
        created_by
        created_by_userId
        created_for_userId
        insurerJson
        vehicleDetails {
          permitType
          policyType
          vehicleType
          makeModelVariant
          fuelType
          registrationYear
          rtoCode
          previousPolicyEndDate
          isPreviousPolicyExpired
          isPreviousYearClaimMade
          previousYearNCB
          vehicleNumber
          insuranceType
          previousPolicyType
          manufacturingDate
          registrationDate
          idv
        }
        members {
          memberId
          title
          firstName
          lastName
          gender
          dateOfBirth
          emailId
          mobileNum
          userAge
          pancardNum
          landLine
        }
        addresses {
          addressType
          addressLine1
          addressLine2
          state
          stateCode
          area
          areaCode
          city
          cityCode
          pincode
          country
        }
        nominees {
          personType
          firstName
          middleName
          lastName
          relationShipWithProposer
          age
          title
          dateOfBirth
        }
        quote {
          quoteId
          discounts {
            discountType
            discountAmount
          }
          odPremium
          tpPremium
          sumAssured
          productId
          term
          basePremium
          serviceTax
          totalPremium
          personalAccident {
            code
            name
            isSelected
            totalPremium
          }
          addonIdList {
            isSelected
            addonCode
            addonName
            addonType
            addonValue
            addonServiceTax
            addonBasePremium
            addonInsuredCount
            interval
            addonTotalPremium
            coverAvailability
          }
          legalLiabilityCover {
            isSelected
            code
            name
            value
            interval
            serviceTax
            basePremium
            coverageType
            totalPremium
            minSumAssured
            maxSumAssured
            claimsCovered
          }
          unnamedPA {
            isSelected
            code
            name
            value
            interval
            metaData
            serviceTax
            basePremium
            coverageType
            totalPremium
            minSumAssured
            maxSumAssured
            claimsCovered
          }
          accessoriesCover {
            isSelected
            code
            name
            value
            interval
            metaData
            serviceTax
            basePremium
            coverageType
            totalPremium
            minSumAssured
            maxSumAssured
            claimsCovered
          }
        }
      }
    }`
  };

  return postData('/graphql-api/graphql?', query);
};



// export const createPaymentSessionAPI = (URL, data) => {
//   let configJson = {
//     url: URL,
//     method: 'post',
//     headers: { 
//       'Content-Type': 'application/json',
//       'Authorization': 'Basic bWVyY2hhbnQuVEVTVDgwODU5NDAwMDphZjYwNzhiNzdlYmU3YTdjZDU5ZWY3YTNlNjg4YTM1Yg==',
//       'xhr.withCredentials': true,
//       'Access-Control-Allow-Origin': '*'
//      },
//     data: data
//   };
//   console.log("cmng here createPaymentSessionAPI ==> ", configJson);
//   return axios(configJson);
// }


export const createPaymentSessionAPI = (URL, data) => {
  let configJson = {
    url: `${config.CHANNEL_PARTNER_INSURER}/v1/channelPartner/callInsurerApi`,
    method: 'post',
    data: {
      url: URL,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Basic bWVyY2hhbnQuVEVTVDgwODU5NDAwMDphZjYwNzhiNzdlYmU3YTdjZDU5ZWY3YTNlNjg4YTM1Yg==',
      },
      payload: data
    }
  };
  // console.log("cmng here createPaymentSessionAPI ==> ", configJson);
  return axios(configJson);
}


export const customUserByToken = (data) => {
  return postData("/api/authentication/v1/getuserdetails", data);
};

export const verifyLoggedInUser = (path) => {
  return getData()
}

// new apis

export const newCreateLifeEnquiry = (path, data) => {
  return postData(path, data);
};

export const newGetLifeEnquiry = (path, data) => {
  return postData(path, data);
};

export const newUpdateLifeEnquiry = (path, data) => {
  return patchData(config.BASE_URL + path, data);
};

export const patchUpdateOrder = (path, data) => {
  return patchData(config.BASE_URL + path, data);
};
export const createProposal = (path, data) => {
  return dynamicPostData(path, data);
};

export const updateLifeOrderWithAddon = (url, request) => {
  const { orderId, payload, response } = request;
  // console.log("paya",payload);
  let query = {
    query: `mutation { updateLifeSavingsOrderWithAddon(
      orderId:${JSON.stringify(orderId).replace(/\"([^(\")"]+)\":/g, "$1:")}
    payload: ${JSON.stringify(payload).replace(/\"([^(\")"]+)\":/g, "$1:")}
    )
    { 
      ${response}
    } 
  } `
  }
  return postData(url, query);
}

export const createProposalData = (data) => {
  let configJson = {
    url: `${config.CHANNEL_PARTNER_URL}v2/channelPartner/workflow/createProposal`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data
  };
  // console.log("getAllDataByDynamicIndexQuery config json ===>>> ", JSON.stringify(configJson));
  return axios(configJson);
}

export const createOrder = (path, data) => {

  return postData(path, data);
};

export const getOrder = (path, data) => {
  return postData(path, data);
};

export const patchOrder = (path, data) => {
  return patchData(config.BASE_URL + path, data);
};

export const updateProposalStatus = (data, Id) => {
  let configJson = {
    url: `${config.CHANNEL_PARTNER_URL}v2/channelPartner/workflow/updateProposalStatus/${Id}`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data
  };
  // console.log("getAllDataByDynamicIndexQuery config json ===>>> ", JSON.stringify(configJson));
  return axios(configJson);
}


export const makeProposalRequest = (orderId) => {
  let configJson = {
    url: `https://channelpartner.tameen.om/v2/channelPartner/proposal`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: {
      category: 'motor',
      orderId: orderId
    }
  };
  // console.log("getAllDataByDynamicIndexQuery config json ===>>> ", JSON.stringify(configJson));
  return axios(configJson);
}

export const makeDomesticProposalRequest = (orderId) => {
  let configJson = {
    url: `https://channelpartner.tameen.om/v5/channelPartner/proposal`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: {
      category: 'domestic',
      orderId: orderId
    }
  };
  return axios(configJson);
}

export const getOrderStatusAPI = (Id) => {
  let configJson = {
    url: `${config.BASE_URL}/api/lorder/lsorder/${Id}/status`,
    method: 'get',
    headers: { 'Content-Type': 'application/json' },
    // data: data
  };
  // console.log("getAllDataByDynamicIndexQuery config json ===>>> ", JSON.stringify(configJson));
  return axios(configJson);
}

export const updateOrderStatusAPI = (data, Id) => {
  let configJson = {
    url: `${config.BASE_URL}/api/lsorder/channelPartner/${Id}/status`,
    method: 'PATCH',
    headers: { 'Content-Type': 'application/json' },
    data: data
  };
  // console.log("getAllDataByDynamicIndexQuery config json ===>>> ", JSON.stringify(configJson));
  return axios(configJson);
}

export const getProposalData = (data) => {
  let configJson = {
    url: `${config.CHANNEL_PARTNER_URL}v2/channelPartner/workflow/getProposalDetails`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data
  };
  // console.log("getAllDataByDynamicIndexQuery config json ===>>> ", JSON.stringify(configJson));
  return axios(configJson);
}

export const getProposalDataStatus = (data) => {

  let configJson = {
    url: `${config.CHANNEL_PARTNER_URL}v2/channelPartner/workflow/getProposalDetails`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data
  };
  // console.log("getAllDataByDynamicIndexQuery config json ===>>> ", JSON.stringify(configJson));
  return axios(configJson).then(resp => {
    if (resp.data && resp.data.payload[0]) {
      // console.log("resp.data.payload[0",resp.data.payload[0].status);
      return resp.data.payload[0].status;
    }
  }).catch(err => {
    console.log("error", err);
  });
}

export const updateAMLKYCData = (data) => {
  let configJson = {
    url: `${Config.BASE_URL}/om-elocker-api/v1/screening/watania`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data
  };
  // console.log("getAllDataByDynamicIndexQuery config json ===>>> ", JSON.stringify(configJson));
  return axios(configJson);
}

export const getValueListFun = (listName) => {

  const data = {
    "apiKey": "watania",
    "secretKey": "DA5EDB62977E2DDA159F25C2D6469",
    "brokerCode": "upsure",
    "channel": "term",
    "categoryCode": "OWILFTM",
    "payload": {
      "channel": "default",
      "listName": listName
    }
  };

  return postData("/api/getChannelValueLists", data)
};


export const serviceRequest = (url, data) => {
  return postData(url, data);
}

export const getPolicyByCoiNumber = (coinumber) => {
  let configJson = {
    url: `${config.BASE_URL}/graphql-api/graphql?`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Cookies': document.cookie.toString(),
    },
    data: {
      query: `{
                getPolicyByCoiNumber(coiNumber:"${coinumber}") {
                  code
                  message
                  payload {
                    uuid
                    channel_name
                    order_id
                    policy_id
                    coi_number
                    policy_number
                    policy_start_date
                    policy_end_date
                    no_policy_renewed
                    current_renew_order_id
                    is_renew
                    policy_status
                    added_date
                    updated_date
                    meta_data
                    status
                  }
                }
              }`
    }
  };
  return axios(configJson)
}

export const getPartnerByQuery = (uuid) => {
  let configJson = {
    url: `${config.BASE_URL}/graphql-api/graphql?`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Cookies': document.cookie.toString(),
    },
    data: {
      query: `{
                    getPartnerByQuery(
                      payload: {
                        query: {
                          bool: {
                            must: {
                              match: {
                                key: "uuid"
                                value: "${uuid}"
                              }
                            }
                          }
                        }
                      }
                    ) {
                      hits {
                        hits {
                          _source {
                          eventMetaData{
                              createdByUserId
                            }
                            mobile
                            role
                            channels
                            basicDetails {
                              profileImage
                              firstName
                              lastName
                              email
                              gender
                              dob
                            }
                            metaData
                            stores{storeName storeId}
                            address {
                              addressType
                              addressLine1
                              addressLine2
                            }
                          }
                        }
                      }
                    }
                  }`
    }
  };
  return axios(configJson);
}



export const getAllPolicyAndOrderForFilter = (userId) => {
  let configJson = {
    url: `${config.BASE_URL}/graphql-api/graphql?`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Cookies': document.cookie.toString(),
    },
    data: {
      query: `{
                getAllPolicyAndOrderForFilter(
                  userId: "${userId}"
                  payload: {
                    from: 0
                    size: 100
                    query: {
                      bool: { must: [{ match: { key: "status", value: "Created" } }] }
                    }
                  }
                ) {
                  policyDetails {
                    policy_id
                    order_id
                    document_id
                    policy_start_date
                    policy_end_date
                    status
                    coi_number
                    document_id
                    channel
                    userId
                    created_by_userId
                  }
                  productDetails {
                    category
                    companyName
                    categoryName
                    categoryCode
                    categoryTitle
                    productName
                    productLogoUrl
                  }
                  quote {
                    quoteId
                    currencyType
                    sumAssured
                    conversion_rate
                    SARBC
                  }
                  proposerInfo {
                    firstName
                    lastName
                    middleName
                    emiratesID
                  }
                  insuredInfo {
                    firstName
                    middleName
                    lastName
                    dateOfBirth
                    emiratesID
                  }
                }
              }`
    }
  };
  return axios(configJson)
}




export const getAllPolicyForFilter = (id) => {
  let policyData = []
  policyData.push({
    match: {
      key: "coi_number",
      value: id
    }
  })
  let final = {
    bool: {
      must: policyData
    }
  };
  var configJson = {
    url: config.BASE_URL + '/graphql-api/graphql?',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Cookies': document.cookie.toString(),
    },
    data: {
      query: `{getAllPolicyForFilter(payload: {query:${JSON.stringify(final).replace(/\"([^(\")"]+)\":/g, "$1:")}}) {hits {hits {_source { policy_id order_id policy_start_date policy_end_date status coi_number document_id channel userId}}}}}`
    }
  };
  return axios(configJson)
}

export const getAllPolicyByFilter = (id) => {
  let policyData = []
  policyData.push({
    match: {
      key: "coi_number",
      value: id
    }
  })
  let final = {
    bool: {
      must: policyData
    }
  };
  var configJson = {
    url: config.BASE_URL + '/graphql-api/graphql?',
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Cookies': document.cookie.toString(),
    },
    data: {
      query: `{getAllPolicyByFilter(payload: {query:${JSON.stringify(final).replace(/\"([^(\")"]+)\":/g, "$1:")}}) {hits {hits {_source { policy_id order_id policy_start_date policy_end_date status coi_number document_id channel userId}}}}}`
    }
  };
  return axios(configJson)
}

export const userPermissionsAPI = (url, data) => {

  return postData(url, data);
}

export const getCorrespondenceAddress = (url) => {
  return getData(config.BASE_URL + url)
}

export const addOnPremiumCalculation = (url, data) => {
  return postData(url, data);
}


// payment common api's   


export function getAllPaymentGateways(channelName) {
  let configJson = {
    url: `${config.BASE_URL}/graphql-api/graphql?`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Cookies': document.cookie.toString(),
    },
    data: {
      query: `query {getPaymentGateWay(payload:${JSON.stringify({ channelName: channelName }).replace(/\"([^(\")"]+)\":/g, "$1:")}){
                  _id
                  channelName
                  products {
                     productId
                     paymentGateWayList {
                                code
                                desc
                                logo
                      }
                  }
              }}`
    }
  };
  return axios(configJson);
}


export function generatePaymentToken(payload) {
  let configJson = {
    url: `${config.BASE_URL}/graphql-api/graphql?`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Cookies': document.cookie.toString(),
    },

    data: {
      query: `query {generatePaymentToken(payload:${payload}) {
                      code
                      message
                      paymentToken
                  }
              }`
    }
  };
  return axios(configJson);
}

export function getLeadDetails(leadId) {
  let configJson = {
    url: `${config.BASE_URL}/graphql-api/graphql?`,
    method: 'post',
    headers: {
      'Content-Type': 'application/json',
      'Cookies': document.cookie.toString(),
    },
    data: {
      query: `{
                viewAllUnifiedLeads(payload:{leadId:"${leadId}"},pageNo :1, pageSize: 10000 ) {
                  code
                  count
                  payload {
                    id
                    leadType
                    mobile
                    userId
                    name
                    source
                    channel
                    cardNumber
                    status
                    verificationStatus
                    score
                    metaData
                  addressMetaData {
                    addressLine1
                    addressLine2
                    pinCode
                    stateCode
                    cityCode
                    stateName
                    cityName
                    latitude
                    longitude
                    placeId
                  }
                    productMetaData {
                      productId
                      name
                      sumInsured
                      term
                      premium
                    }
                    assignedTo {
                      uuid
                      role
                    }
                    createdBy
                    createdByUserId
                    updatedBy
                    updatedByUserId
                    createdAt
                    updatedAt
                  }
                }
              }`
    }
  };
  return axios(configJson).then(res => res.data.data.viewAllUnifiedLeads);
}

export const patchProposal = (path, data) => {
  return patchData(path, data);
};

export const getUserByToken = () => {
  const getCookie = (name) => {
    let dc = document.cookie;
    let prefix = name + "=";
    let begin = dc.indexOf("; " + prefix);
    if (begin === -1) {
      begin = dc.indexOf(prefix);
      if (begin !== 0) return null;
    } else {
      begin += 2;
    }
    let end = dc.indexOf(";", begin);
    if (end === -1) {
      end = dc.length;
    }
    return decodeURIComponent(dc.substring(begin + prefix.length, end));
  }
  const token = getCookie("Authorization");
  // console.log("token33",token);
  const configJson = { token }
  return axios.post(`${Config.BASE_URL}/api/authentication/v1/user/token/firebase/get`, configJson)
}

export const getUserData = () => {
  const getCookie = (name) => {
    let dc = document.cookie;
    let prefix = name + "=";
    let begin = dc.indexOf("; " + prefix);
    if (begin === -1) {
      begin = dc.indexOf(prefix);
      if (begin !== 0) return null;
    } else {
      begin += 2;
    }
    let end = dc.indexOf(";", begin);
    if (end === -1) {
      end = dc.length;
    }
    return decodeURIComponent(dc.substring(begin + prefix.length, end));
  }
  const idToken = getCookie("idToken");
  // console.log("idToken00",idToken);
  let configJson = {
    "token": idToken,
    "application": "digi-life" //asdasd
  }
  return axios.post(`${config.BASE_URL}/api/authentication/v1/getuserdetails`, configJson)
}
export const getTokenByUUID = (uuid) => {
  // const token = getCookie("Authorization");
  // console.log("uuid",uuid);
  return axios.get(Config.BASE_URL + "/api/authentication/v1/user/getTokenByUUID?uuid=" + uuid)
}


export const getSelectedAddons = (id) => {
  return getData(`${config.CHANNEL_PARTNER_URL}v1/channelPartner/getUserPremiumQuoteDetails/${id}`)
}



// all travel api here  

export const createTravelOrder = (payload) => {
  let url = `/api/morder/travelOrder`
  return postData(url, payload);
}

export const updateTravelOrder = (payload, id) => {
  let url = `/api/morder/travelOrder/${id}`
  return patchData(url, payload);
}

export const getTravelOrder = (orderID) => {
  let url = `api/morder/travelOrder/${orderID}`
  return getData(url);
}

export const getTravelEnquiry = (enquiryId) => {
  let url = `/api/tenquiry/${enquiryId}`
  return getData(url);
}

export const getDomesticEnquiry = (enquiryId) => {
  let url = `/api/denquiry/${enquiryId}`
  return getData(url);
}

export const createDomesticOrder = (payload) => {
  let url = `/api/morder/domesticOrder`
  return postData(url, payload);
}

export const getDomesticOrder = (id) => {
  let url = `/api/morder/domesticOrder/${id}`
  return getData(url);
}

export const patchDomesticOrder = (id, payload) => {
  let url = `/api/morder/domesticOrder/${id}`
  return patchData(url, payload);
}

export const makeTravelProposalRequest = (orderId) => {
  let configJson = {
    url: `${config.CHANNEL_PARTNER_INSURER}/v2/channelPartner/proposal`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: {
      category: 'travel',
      orderId: orderId
    }
  };
  // console.log("getAllDataByDynamicIndexQuery config json ===>>> ", JSON.stringify(configJson));
  return axios(configJson);
}


export const createServiceRequestOfFeedback = (data) => {

  let configJson = {
    url: `${config.INSURANCE_API}/api/claim/createAndUpdateServiceRequestForAR`,
    method: 'post',
    headers: { 'Content-Type': 'application/json' },
    data: data
  }

  return axios(configJson)

}

export const sendLeadNotificationEmail = async (leadData, sourceType, uniqueId) => {
  let mailBody = `
    Dear Team,<br/><br/>
    A new customer lead has been submitted through the lead generation page. Please find the details below:<br/><br/>
    🧾 <strong>Lead Details:</strong><br/>
  `;

  if (leadData.name) {
    mailBody += `Name: ${leadData.name}<br/>`;
  }
  if (leadData.mobile) {
    mailBody += `Mobile Number: ${leadData.mobile}<br/>`;
  }
  if (leadData.email) {
    mailBody += `Email ID: ${leadData.email}<br/>`;
  }
  if (leadData.typeOfFeedBack) {
    mailBody += `Type of Feedback: ${leadData.typeOfFeedBack}<br/>`;
  }
  if (leadData.summary) {
    mailBody += `Summary: ${leadData.summary}<br/>`;
  }
  if (leadData.description) {
    mailBody += `Additional Details / Comments:<br/>${leadData.description}<br/>`;
  }
  if (uniqueId) {
    mailBody += `ID:<br/>${uniqueId}<br/>`;
  }

  if (Array.isArray(leadData.documents_list) && leadData.documents_list.length > 0) {
    mailBody += `<br/><strong>📎 Uploaded Documents:</strong><br/>`;
    leadData.documents_list.forEach((doc, index) => {
      const documentId = doc.document_id;
      const fileName = doc.document_type || `Document ${index + 1}`;
      if (documentId) {
        const documentLink = `${Config.BASE_URL}/om-elocker-api/rest/elocker/document/${documentId}`;
        mailBody += `${index + 1}. <a href="${documentLink}" target="_blank" rel="noopener noreferrer">${fileName}</a><br/>`;
      } else {
        mailBody += `${index + 1}. ${fileName} (No link available)<br/>`;
      }
    });
  }


  mailBody += `<br/>Source: ${sourceType || "Request a Call Back"}<br/><br/>
    📌 Please reach out to the customer at the earliest and update the CRM accordingly.<br/><br/>
    Warm regards,<br/>
    <strong>Tameen.om</strong>
  `;

  const emailPayload = {
    recipients: ["care@tameen.om"],
    // recipients: ["pragati@tameen.om"],
    body: mailBody,
    subject: `New Customer Lead Received${leadData.name ? " – " + leadData.name : ""}`,
    attachments: [],
    flag: "false",
    fromClient: "Tameen",
  };

  try {
    await axios.post(`${Config.PAYMENT_URL}/api/v1/payments/sendmail`, emailPayload, {
      headers: {
        "Content-Type": "application/json",
      },
    });
  } catch (err) {
    console.error("Mail API Error:", err);
  }
};


export const uploadFeedBackDocument = async (index, file) => {

  let blob = file?.slice(0, file.size, file.type)

  let newFile = new File([blob], file.name.split(".").slice(0, file.name.split(".").length - 1).join('.').concat("_" + Math.floor(new Date() / 1000)).concat(".").concat(file.name.split(".")[file.name.split(".").length - 1]), { type: file.type });

  let formData = new FormData();
  formData.append('document', newFile);
  formData.append('object', `${Date.now()}`);
  formData.append('objectId', (Date.now() + new Date().getTime()));
  formData.append('uploadFolder', 'digimotor' + (Date.now()));
  console.log("docs", formData);

  return axios.post(`${config.BASE_URL}/om-elocker-api/rest/elocker/document`, formData)
    .then(data => { return { "document_id": data.data._id, "document_type": data.data.fileName } })

}
export const getUserPermissions = (uuid) => {
  return axios.get(config.BASE_URL + '/api/authentication/v1/user/firebase/get?uuid=' + uuid).then(res => res.data);
}


// mis service Api


export const getPartnerByUUID = async (uuid) => {
  try {
    const query = `
      {
        getPartnerByQuery(payload:{
          query:{
            bool:{
              must:{
                match:{
                  key:"uuid",
                  value:"${uuid}"
                }
              }
            }
          }
        }){
          hits{
            hits{
              _source{
                activities{
                  channel
                  levels
                }
                uuid
                mobile
                channels
                 stores {
                      storeId
                      storeName
                    }
              }
            }
          }
        }
      }
    `;

    const config = {
      url: `${Config.BASE_URL}/graphql-api/graphql?`,
      method: 'post',
      headers: { 'Content-Type': 'application/json', "Cookies": document.cookie.toString() },
      data: { query },
    };

    const response = await axios(config);
    const hits = response.data?.data?.getPartnerByQuery?.hits?.hits;

    if (hits && hits.length > 0) {
      return hits[0];
    } else {
      return []; // No data found
    }

  } catch (error) {
    console.error("Error fetching partner channels:", error);
    throw error;
  }
};

export const getAllIndexOrderForFilter = async (state) => {
  const filters = buildQueryFilters(state);
  const hasDateRange = state.fromDate && state.toDate;
  // from: ${(state.pageNo || 1) - 1},
  // size: ${state.pageSize || 10}
  const finalQuery = hasDateRange
    ? {
      range: {
        key: 'eventMetaData.created_at',
        gte: state.fromDate,
        lte: state.toDate,
      },
      bool: { must: filters },
    }
    : {
      bool: { must: filters },
    };

  const queryPayload = `query {
    getAllIndexOrderForFilter(payload: {
      query: ${JSON.stringify(finalQuery).replace(/\"([^(\")"]+)\":/g, "$1:")},
      from:${(state.pageNo || 1) - 1},
      size:${state.pageSize || 30}
    }) {
      took
      hits {
        total
        hits {
          _index
          _source
          _id
        }
      }
    }
  }`;

  const config2 = {
    url: `${Config.BASE_URL}/graphql-api/graphql?`,
    method: 'post',
    headers: { 'Content-Type': 'application/json', "Cookies": document.cookie.toString() },
    data: { query: queryPayload },
  };

  try {
    const response = await axios(config2);
    return response.data?.data?.getAllIndexOrderForFilter?.hits || { total: 0, hits: [] };
  } catch (error) {
    console.error('Error fetching index enquiries:', error);
    throw error;
  }
};

export const cancelOrderOrPolicyApi = (path, data) => {
  return patchData(config.BASE_URL + path, data);
};

export const getAllIndexEnquiryForFilter = async (state) => {
  const filters = buildQueryFiltersEnquiry(state);
  const hasDateRange = state.fromDate && state.toDate;
  // from: ${(state.pageNo || 1) - 1},
  // size: ${state.pageSize || 10}
  const finalQuery = hasDateRange
    ? {
      range: {
        key: 'created_at',
        gte: state.fromDate,
        lte: state.toDate,
      },
      bool: { must: filters },
    }
    : {
      bool: { must: filters },
    };

  const queryPayload = `query {
    getAllIndexEnquiryForFilter(payload: {
      query: ${JSON.stringify(finalQuery).replace(/\"([^(\")"]+)\":/g, "$1:")},
      from:${(state.pageNo || 1) - 1},
      size:${state.pageSize || 30}
    }) {
      took
      hits {
        total
        hits {
          _index
          _source
          _id
        }
      }
    }
  }`;

  const config2 = {
    url: `${Config.BASE_URL}/graphql-api/graphql?`,
    method: 'post',
    headers: { 'Content-Type': 'application/json', "Cookies": document.cookie.toString() },
    data: { query: queryPayload },
  };

  try {
    const response = await axios(config2);
    return response.data?.data?.getAllIndexEnquiryForFilter?.hits || { total: 0, hits: [] };
  } catch (error) {
    console.error('Error fetching index enquiries:', error);
    throw error;
  }
};

export const getAllIndexOrderFullInfoByFilter = (inputJson) => {
  let configJson = {
    url: `${config.BASE_URL}/graphql-api/graphql?`,
    method: 'post',
    headers: { 'Content-Type': 'application/json', "Cookies": document.cookie.toString() },
    data: {
      query: `{
                getAllIndexOrderFullInfoForFilter(payload: ${JSON.stringify(inputJson).replace(/\"([^(\")"]+)\":/g, "$1:")}) {
                  hits {
                    total
                    grandTotalPremium
                    hits {
                      _index
                      _type
                      _id
                      _source {
                        order_id
                        status
                        created_by
                        created_by_userId
                        created_at
                        updated_at
                        name
                        mobile
                        licenseId
                        SBTag
                        email
                        channel
                        companyName
                        location
                        storeId
                        localHead
                        isRenewal
                        vehicleDetails{
                          idv
                          vehicleNumber
                          policyType
                        }
                        insurerJson
                        policy{
                           policy_id
                           coi_number
                           document_id
                           policy_start_date
                           policy_end_date
                           sumAssured
                           totalPremium
                        }
                        quote{
                          basePremium
                          sumAssured
                          totalPremium
                          serviceTax
                          odPremium
                          tpPremium
                        }
                        metaDataJson
                        members{
                            firstName
                            lastName
                            mobileNum
                            emailId
                        }
                      } 
                      }
                    }
                  }
                }`
    }
  };
  return axios(configJson).then(response => response.data.data.getAllIndexOrderFullInfoForFilter);

}


export const getAllLeads = (pageNo = 1, pageSize = 200) => {
  const query = {
    query: `mutation {
        getAllServiceRequestsWithFilter(
          pageNo: ${pageNo},
          pageSize: ${pageSize},
          payload: {
            service_type: "GeneralLeadRequest"
          }
        ) {
          code
          message
          count
          payload
        }
      }`
  };

  return postData('/graphql-api/graphql?', query);
};


const buildQueryFiltersEnquiry = (state) => {
  const data = [];
  if (state.channel && state.channel !== 'All') {
    data.push({ match: { key: 'channel', value: state.channel } });
  } else if (state.channel === 'All') {
    const array = state.channelConcat();
    data.push({ match: { key: 'channel', value: array } });
  }
  if (!!state?.branchId) {
    data.push({
      match: {
        key: "metaDataJson.branchId",
        value: state?.branchId ? state?.branchId.trim() : ''
      }
    })
  }
  if (state.status) {
    data.push({ match: { key: 'status', value: state.status } });
  }

  if (state.policyType) {
    data.push({ match: { key: 'vehicleDetails.policyType', value: state.policyType } });
  }

  if (state.mobile) {
    // const value = state.typeOptions === 'mobile' && state.search.length === 10
    //   ? `+91${state.search}`
    //   : state.search;

    data.push({ match: { key: 'members.mobileNum', value: state.mobile } });
  }
  if (state.plateNumber) {
    data.push({ match: { key: "vehicleDetails.vehicleNumber", value: state.plateNumber } })
  }

  return data;
};

const buildQueryFilters = (state) => {
  const data = [];
  if (state.channel && state.channel !== 'All') {
    data.push({ match: { key: 'channel', value: state.channel } });
  } else if (state.channel === 'All') {
    const array = state.channelConcat();
    data.push({ match: { key: 'channel', value: array } });
  }

  if (state.status) {
    data.push({ match: { key: 'status', value: state.status } });
  }
  if (!!state?.branchId) {
    data.push({
      match: {
        key: "metaDataJson.branchId",
        value: state?.branchId ? state?.branchId.trim() : ''
      }
    })
  }
  if (state.policyType) {
    data.push({ match: { key: 'vehicleDetails.policyType', value: state.policyType } });
  }

  if (state.mobile) {
    let mobileValue = state.mobile;

    if (/^\d{8}$/.test(state.mobile)) {
      // If 8-digit number → add 968
      mobileValue = `968${state.mobile}`;
    } else if (/^\d{10}$/.test(state.mobile)) {
      // If 10-digit number → add 91
      mobileValue = `91${state.mobile}`;
    }

    data.push({ match: { key: 'members.mobileNum', value: mobileValue } });
  }
  if (state.plateNumber) {
    data.push({ match: { key: "vehicleDetails.vehicleNumber", value: state.plateNumber } })
  }

  return data;
};

export const searchVehicleData = (payload) => {
  let url = `${Config.CHANNEL_PARTNER_URL}v1/channelPartner/fetchRopAndVinDetails`
  return axios.post(url, payload, {
    headers: {
      "Content-Type": "application/json"
    }
  }).then(resp => {
    return resp?.data;
  }).catch(err => {
    return err;
  });
}

export const getMotorAuditLogs = (payload) => {
  let url = `${Config.CHANNEL_PARTNER_URL}v1/channelPartner/getMotorAuditLogs`;
  return axios.post(url, payload, {
    headers: {
      "Content-Type": "application/json"
    }
  }).then(resp => {
    return resp?.data;
  }).catch(err => {
    return err;
  });
}

// ======================================
// STRAPI BLOG CMS APIs
// ======================================

const STRAPI_URL =
  process.env.REACT_APP_STRAPI_URL || "https://cms.tameen.om/api";

export const getBlogs = (locale = "en", categorySlug = null, tagSlug = null, pageSize = 100) => {
  let url = `${STRAPI_URL}/posts?populate=*&locale=${locale}&pagination[pageSize]=${pageSize}`;
  if (categorySlug) {
    url += `&filters[category][Slug][$eq]=${categorySlug}`;
  }
  if (tagSlug) {
    url += `&filters[tags][slug][$eq]=${tagSlug}`;
  }
  return axios.get(url);
};

export const getCategories = (locale = "en") => {
  return axios.get(
    `${STRAPI_URL}/categories?locale=${locale}&pagination[pageSize]=100`
  );
};

export const getTags = (locale = "en") => {
  return axios.get(
    `${STRAPI_URL}/tags?locale=${locale}&pagination[pageSize]=100`
  );
};


export const getBlogBySlug = (
  slug,
  locale = "en"
) => {
  return axios.get(
    `${STRAPI_URL}/posts?filters[slug][$eq]=${slug}&populate=*&locale=${locale}`
  );
};


export const getSingleBlog = (
  slug,
  locale = "en"
) => {
  return axios.get(
    `${STRAPI_URL}/posts?filters[slug][$eq]=${slug}&populate[0]=featuredImage&populate[1]=tableOfContents.items&populate[2]=category&populate[3]=ogImage&populate[4]=blogSections&populate[5]=blogSections.image&populate[6]=blogSections.items&populate[7]=blogSections.content&populate[8]=blogSections.video&populate[9]=blogSections.thumbnail&populate[10]=tags&populate[11]=authorImage&populate[12]=blogSections.backgroundImage&populate[13]=blogSections.buttonIcon&populate[14]=blogSections.description&populate[15]=blogSections.headers&populate[16]=blogSections.rows&populate[17]=blogSections.rows.cells&locale=${locale}`
  );
};

export const getPageBySlug = (slug, locale = "en") => {
  return axios.get(
    `${STRAPI_URL}/pages?filters[Slug][$eq]=${slug}&locale=${locale}&populate[0]=pageBuilder.backgroundDesktop&populate[1]=pageBuilder.backgroundMobile&populate[2]=pageBuilder.CTAButton.icon&populate[3]=pageBuilder.image&populate[4]=pageBuilder.faqItems&populate[5]=pageBuilder.CTAButtons.icon&populate[6]=pageBuilder.metaImage&populate[7]=pageBuilder.shareImage&populate[8]=pageBuilder.icon`
  );
};

const PRELOADED_QUOTE_TTL_MS = 5 * 60 * 1000;
const PRELOADED_QUOTE_MAX_ENTRIES = 5;

const preloadedQuotes = new Map();

const canonicalizePayload = (value) => {
  if (Array.isArray(value)) {
    return [...value]
      .map(canonicalizePayload)
      .sort((a, b) => (JSON.stringify(a) < JSON.stringify(b) ? -1 : 1));
  }
  if (value && typeof value === "object") {
    return Object.keys(value)
      .sort()
      .reduce((acc, key) => {
        acc[key] = canonicalizePayload(value[key]);
        return acc;
      }, {});
  }
  return value;
};

const buildCacheKey = (enquiryId, payload) =>
  `${enquiryId}::${JSON.stringify(canonicalizePayload(payload))}`;

const sweepExpired = () => {
  const now = Date.now();
  for (const [key, entry] of preloadedQuotes) {
    if (now - entry.timestamp > PRELOADED_QUOTE_TTL_MS) {
      preloadedQuotes.delete(key);
    }
  }
};

export const setPreloadedQuote = (enquiryId, payload, promise) => {
  sweepExpired();
  while (preloadedQuotes.size >= PRELOADED_QUOTE_MAX_ENTRIES) {
    const oldestKey = preloadedQuotes.keys().next().value;
    preloadedQuotes.delete(oldestKey);
  }
  preloadedQuotes.set(buildCacheKey(enquiryId, payload), {
    enquiryId,
    promise,
    timestamp: Date.now()
  });
};

export const getPreloadedQuote = (enquiryId, currentPayload) => {
  const key = buildCacheKey(enquiryId, currentPayload);
  const entry = preloadedQuotes.get(key);
  if (!entry) return null;

  if (Date.now() - entry.timestamp > PRELOADED_QUOTE_TTL_MS) {
    preloadedQuotes.delete(key);
    return null;
  }

  return entry.promise;
};

export const clearPreloadedQuote = (enquiryId) => {
  for (const [key, entry] of preloadedQuotes) {
    if (entry.enquiryId === enquiryId) {
      preloadedQuotes.delete(key);
    }
  }
};

export const clearAllPreloadedQuotes = () => {
  preloadedQuotes.clear();
};
